import { render, staticRenderFns } from "./ProgressNote.vue?vue&type=template&id=789f4014"
import script from "./ProgressNote.vue?vue&type=script&lang=js"
export * from "./ProgressNote.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports